import { css } from '@emotion/react';
import { transition } from '../../utils/styleUtils';
export const themeDayIconStyles = css({
    stroke: 'none',
    transition: transition({
        attributes: [
            'transform'
        ],
        easing: 'wobbly'
    }),
    [`a:hover &, a:focus &, 
        button:hover &, button:focus &`]: {
        transform: 'scale(1.1)'
    }
});
